// ============================================================
// CLUBHUB – Nachrichten: Markdown zeichnen
// ============================================================
// Zeichnet den Baum aus `lib/nachrichten/markdown.ts` mit React —
// jeder Text wird dabei maskiert, kein `dangerouslySetInnerHTML`.
// Ohne Zustand, laeuft auf dem Server wie im Browser.
// ============================================================
import { Fragment } from "react";
import { cn } from "@/lib/utils";
import { parse, type Inline } from "@/lib/nachrichten/markdown";

function Zeile({ teile }: { teile: Inline[] }) {
  return (
    <>
      {teile.map((x, i) => {
        if (x.t === "text") return <Fragment key={i}>{x.v}</Fragment>;
        if (x.t === "br") return <br key={i} />;
        if (x.t === "b") return <strong key={i} className="font-semibold"><Zeile teile={x.c} /></strong>;
        if (x.t === "i") return <em key={i}><Zeile teile={x.c} /></em>;
        return (
          <a key={i} href={x.href} target="_blank" rel="noreferrer noopener" className="text-accent underline underline-offset-2">
            <Zeile teile={x.c} />
          </a>
        );
      })}
    </>
  );
}

export function MarkdownText({ text, className }: { text: string; className?: string }) {
  const bloecke = parse(text);
  return (
    <div className={cn("space-y-3", className)}>
      {bloecke.map((b, i) => {
        if (b.t === "p") return <p key={i}><Zeile teile={b.c} /></p>;
        if (b.t === "h")
          return b.ebene === 2 ? (
            <h2 key={i} className="text-heading-sm text-text-primary pt-2">
              <Zeile teile={b.c} />
            </h2>
          ) : (
            <h3 key={i} className="text-body-md text-text-primary pt-1 font-semibold">
              <Zeile teile={b.c} />
            </h3>
          );
        const Liste = b.t === "ul" ? "ul" : "ol";
        return (
          <Liste key={i} className={cn("space-y-1 pl-5", b.t === "ul" ? "list-disc" : "list-decimal")}>
            {b.items.map((it, k) => (
              <li key={k} className="pl-1">
                <Zeile teile={it} />
              </li>
            ))}
          </Liste>
        );
      })}
    </div>
  );
}
